import React from "react";

const Select = ({ name, value, onChange, required, children, className, id, label }) => (
  <select
    id={id || name}
    name={name}
    value={value}
    onChange={onChange}
    required={required}
    aria-label={label || name}
    className={`w-full px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className || ""}`}
  >
    {children}
  </select>
);

export default Select;